<template>
  <div class="circle-graph-container">
    <div class="information-container">
      
    </div>
    <div class="graph-container">
      <div class="information-title">Projects Finished</div>
      <svg class="graph" ref="svg" viewBox="0 0 260 260"></svg>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  mounted() {
    this.svg = d3.select(this.$refs.svg);
    this.initChart();
  },

  methods: {
    getCurrentMetric() {
      return this.$store.state.simulator.performanceTracker.metrics[this.$store.state.dashboard.slider];
    },

    initChart() {
      var self = this;
      //Get svg size
      var width = this.svg.node().getBoundingClientRect().width / 2;
      var height = this.svg.node().getBoundingClientRect().height / 2;

      width = 130;
      height = 130;

      this.chart = this.svg.append("g").attr("transform", "translate(" + width + "," + height + ")");

      this.currentProjectText = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -20).text(this.getCurrentMetric().finishedProjects).style("font-family", "Open Sans").style("font-size", "160px").style("font-weight", "600").style("fill", "rgba(110, 188, 44, 1)");
    },

    updateChart() {
      this.currentProjectText.text(this.getCurrentMetric().finishedProjects);
    },
  },
  data: () => ({
    svg: null,
  }),
};
</script>

<style scoped>
.circle-graph-container {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;  
}

.graph-container {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  overflow: hidden;
}

.information-container {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
}

.custom-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--bullet-color, black); /* Default color is black */
  display: inline-block;
  margin-right: 5px;
}

.graph {
  position: relative;
  padding: 0;
  margin: 0;
  top: 0%;
  height: 45%;
  aspect-ratio: 1/1;
}

.icon-container {
  margin-left: 10px;
  justify-content: center;
  align-items: center;

  display: flex;
  flex-direction: column;
}

.legend-item {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: rgba(128, 128, 128, 1);
  width: 150px;
}
.legend-information {
  display: flex;
  flex-direction: row;
}
.legend-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
  min-height: 48px;
}

.icon {
  width: 20px;
  height: 20px;

  margin-top: 2px;
}



.information-title {
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: rgba(74, 74, 74, 1);
}
</style>
